import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

const testimonials = [
  {
    name: '资深娱乐记者 王老师',
    role: '从业15年',
    content: '91爆料网是业内公认的信息聚合最全面、更新最及时的娱乐资讯平台。我每天第一件事就是打开91爆料网看看今天有什么新瓜，已经成为职业习惯了。',
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20portrait%20style%20avatar%20with%20warm%20coral%20background%2C%20simple%20abstract%20face%20illustration%2C%20clean%20flat%20design%2C%20professional%20style&width=120&height=120&seq=about-avatar-01&orientation=squarish',
  },
  {
    name: '自媒体人 小李',
    role: '吃瓜8年',
    content: '作为一个自媒体人，91爆料网就是我的素材库。每次有什么热点事件，这里总能找到最全面的资料和最新的进展。内容质量很高，不是那种只会博眼球的标题党。',
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20portrait%20style%20avatar%20with%20olive%20green%20background%2C%20simple%20abstract%20face%20illustration%2C%20clean%20flat%20design%2C%20professional%20style&width=120&height=120&seq=about-avatar-02&orientation=squarish',
  },
  {
    name: '忠实用户 大西瓜',
    role: '日活用户',
    content: '91爆料网是我用过最好的吃瓜平台！界面简洁干净，内容更新快，评论区也特别有意思。每天早晚各刷一遍，已经是我雷打不动的习惯了。',
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20portrait%20style%20avatar%20with%20warm%20amber%20background%2C%20simple%20abstract%20face%20illustration%2C%20clean%20flat%20design%2C%20friendly%20style&width=120&height=120&seq=about-avatar-03&orientation=squarish',
  },
];

const faqs = [
  {
    question: '91爆料网的内容来源是什么？',
    answer: '91爆料网的内容来自多渠道信息整合，包括公开新闻报道、社交媒体动态、网友投稿以及编辑团队的独立调查。我们坚持多方交叉验证的原则，确保每一条爆料信息都具有可信的基础。同时，我们也会明确标注信息来源，让读者自行判断信息可信度。',
  },
  {
    question: '如何向91爆料网投稿或提供线索？',
    answer: '我们非常欢迎广大吃瓜群众提供爆料线索。你可以通过页面底部的邮箱地址发送投稿内容，也可以通过微信公众号私信我们。对于有价值的独家线索，我们会安排编辑团队进行深度追踪和调查。所有投稿者信息将严格保密。',
  },
  {
    question: '91爆料网的内容是否保证真实性？',
    answer: '我们尽最大努力确保内容的真实性和准确性。对于每一条爆料，编辑团队都会进行多方交叉验证。但由于爆料内容的特殊性，部分信息可能来源于匿名渠道，我们会在文章中明确标注。我们鼓励读者保持理性态度，不传谣不信谣。',
  },
  {
    question: '91爆料网有手机App吗？',
    answer: '目前91爆料网的移动端正在紧锣密鼓地开发中，即将推出iOS和Android双平台App。在App上线之前，你可以通过手机浏览器访问我们的网站，网站已针对移动端进行了全面优化，浏览体验流畅。',
  },
];

export default function AboutPage() {
  return (
    <>
      <Navbar />
      <main>
        <section className="relative w-full h-[400px] md:h-[480px] overflow-hidden mx-auto px-4 md:px-6 pt-20">
          <div className="relative w-full h-full rounded-3xl overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=Abstract%20artistic%20composition%20with%20warm%20terracotta%20and%20cream%20gradients%2C%20flowing%20organic%20shapes%2C%20modern%20editorial%20design%20aesthetic%2C%20soft%20textured%20overlay%2C%20professional%20sophisticated%20atmosphere%2C%20clean%20minimalist%20composition%2C%20magazine%20cover%20style%2C%20warm%20inviting%20tone&width=1800&height=900&seq=about-hero-bg&orientation=landscape"
              alt="关于91爆料网"
              className="absolute inset-0 w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/45"></div>
            <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-4">
              <nav className="flex items-center gap-2 text-white/70 text-xs mb-4" aria-label="面包屑导航">
                <Link to="/" className="hover:text-white transition-colors cursor-pointer">首页</Link>
                <i className="ri-arrow-right-s-line"></i>
                <span className="text-white">关于我们</span>
              </nav>
              <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-white/25 bg-white/10 backdrop-blur-sm mb-4">
                <i className="ri-information-line text-primary-400 text-sm"></i>
                <span className="text-white/90 text-xs font-medium">了解我们</span>
              </div>
              <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold font-heading text-white">
                关于91爆料网
              </h1>
              <p className="mt-3 text-sm md:text-base text-white/70 max-w-xl">
                全网独家吃瓜黑料第一站，你的吃瓜核心阵地
              </p>
            </div>
          </div>
        </section>

        <section className="bg-background-100 py-14 md:py-20 px-4 md:px-6">
          <div className="mx-auto max-w-4xl">
            <div className="mb-12">
              <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-4">
                品牌介绍
              </span>
              <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-6">
                全网吃瓜群众的<span className="text-accent-600">核心阵地</span>
              </h2>
              <div className="flex flex-col gap-4 text-foreground-700 leading-relaxed text-base">
                <p>
                  91爆料网成立于2024年，是国内领先的娱乐资讯与网红爆料聚合平台。我们致力于为吃瓜群众提供最新、最全、最真实的爆料内容，涵盖网红翻车、娱乐圈大事件、独家深度调查等多个领域。
                </p>
                <p>
                  作为全网独家吃瓜黑料第一站，91爆料网拥有一支专业的编辑团队和广泛的线索网络。我们的内容覆盖了从网红圈到娱乐圈的方方面面，无论是直播翻车、恋情曝光、数据造假还是行业黑幕，你都能在这里找到最及时的报道。
                </p>
                <p>
                  我们不只是一个爆料平台，更是一个吃瓜社区。在这里，你可以看到来自全国各地的吃瓜群众的热议和观点碰撞。我们相信，健康的讨论和交流能够让整个互联网环境变得更好。
                </p>
              </div>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-12">
              <div className="bg-background-50 rounded-xl p-5 text-center">
                <div className="text-2xl font-bold font-heading text-primary-500 mb-1">1000万+</div>
                <p className="text-xs text-foreground-500">月活跃用户</p>
              </div>
              <div className="bg-background-50 rounded-xl p-5 text-center">
                <div className="text-2xl font-bold font-heading text-accent-500 mb-1">5000+</div>
                <p className="text-xs text-foreground-500">累计爆料文章</p>
              </div>
              <div className="bg-background-50 rounded-xl p-5 text-center">
                <div className="text-2xl font-bold font-heading text-secondary-500 mb-1">50万+</div>
                <p className="text-xs text-foreground-500">每日评论互动</p>
              </div>
              <div className="bg-background-50 rounded-xl p-5 text-center">
                <div className="text-2xl font-bold font-heading text-primary-500 mb-1">99.7%</div>
                <p className="text-xs text-foreground-500">用户满意度</p>
              </div>
            </div>
          </div>
        </section>

        <section className="bg-background-50 py-14 md:py-20 px-4 md:px-6">
          <div className="mx-auto max-w-4xl">
            <div className="text-center mb-10">
              <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-4">
                用户口碑
              </span>
              <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-2">
                听听他们<span className="text-accent-600">怎么说</span>
              </h2>
              <p className="text-sm text-foreground-500">来自真实用户的评价</p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
              {testimonials.map((t, i) => (
                <div key={i} className="bg-background-100 rounded-xl p-6 flex flex-col gap-4">
                  <div className="flex items-center gap-3">
                    <div className="w-12 h-12 rounded-full overflow-hidden flex-shrink-0">
                      <img src={t.avatar} alt={t.name} className="w-full h-full object-cover" />
                    </div>
                    <div>
                      <p className="text-sm font-semibold text-foreground-900">{t.name}</p>
                      <p className="text-xs text-foreground-500">{t.role}</p>
                    </div>
                  </div>
                  <div className="relative flex-1">
                    <i className="ri-double-quotes-l text-xl text-accent-300 absolute -top-1 -left-1"></i>
                    <p className="text-sm text-foreground-700 leading-relaxed pl-4">{t.content}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="bg-background-100 py-14 md:py-20 px-4 md:px-6">
          <div className="mx-auto max-w-4xl">
            <div className="text-center mb-10">
              <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-4">
                常见问题
              </span>
              <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-2">
                你可能<span className="text-accent-600">想知道</span>
              </h2>
            </div>

            <div className="flex flex-col gap-4">
              {faqs.map((faq, i) => (
                <details key={i} className="group bg-background-50 rounded-xl overflow-hidden">
                  <summary className="p-5 flex items-center justify-between cursor-pointer list-none">
                    <span className="text-sm font-semibold text-foreground-900 pr-4">{faq.question}</span>
                    <i className="ri-arrow-down-s-line text-foreground-400 group-open:rotate-180 transition-transform flex-shrink-0"></i>
                  </summary>
                  <div className="px-5 pb-5">
                    <p className="text-sm text-foreground-600 leading-relaxed">{faq.answer}</p>
                  </div>
                </details>
              ))}
            </div>
          </div>
        </section>

        <section className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
          <div className="mx-auto max-w-7xl">
            <div className="flex flex-col lg:flex-row gap-0 rounded-2xl overflow-hidden">
              <div className="lg:w-1/2 relative h-64 md:h-80 lg:h-auto overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Abstract%20artistic%20composition%20with%20warm%20coral%20and%20cream%20gradients%2C%20soft%20organic%20shapes%2C%20modern%20editorial%20design%2C%20clean%20minimalist%20aesthetic%2C%20sophisticated%20textured%20background%2C%20professional%20inviting%20tone&width=1000&height=700&seq=about-contact-bg&orientation=landscape"
                  alt="联系我们"
                  className="absolute inset-0 w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-r from-black/20 to-transparent"></div>
                <div className="absolute left-6 top-6">
                  <span className="inline-block px-3 py-1 rounded-full bg-white/20 backdrop-blur-sm text-white text-xs font-medium">
                    联系我们
                  </span>
                </div>
                <div className="absolute left-6 bottom-6">
                  <p className="text-2xl md:text-3xl font-bold font-heading text-white leading-tight">
                    爆料投稿<br />广告合作
                  </p>
                </div>
              </div>
              <div className="lg:w-1/2 bg-background-100 flex flex-col items-center justify-center text-center p-8 md:p-12 lg:p-14">
                <h3 className="text-xl md:text-2xl font-bold font-heading text-foreground-950 mb-4">
                  与我们取得联系
                </h3>
                <p className="text-sm text-foreground-600 max-w-md mb-8 leading-relaxed">
                  无论你是想提供爆料线索、洽谈商业合作，还是有其他任何问题，都欢迎通过以下方式联系我们。我们会在24小时内回复。
                </p>
                <div className="flex flex-col gap-3 w-full max-w-xs">
                  <div className="flex items-center gap-3 text-sm text-foreground-700">
                    <div className="w-9 h-9 rounded-lg bg-primary-100 flex items-center justify-center flex-shrink-0">
                      <i className="ri-mail-line text-primary-600"></i>
                    </div>
                    <span>hello@cyhkjo.cn</span>
                  </div>
                  <div className="flex items-center gap-3 text-sm text-foreground-700">
                    <div className="w-9 h-9 rounded-lg bg-accent-100 flex items-center justify-center flex-shrink-0">
                      <i className="ri-wechat-line text-accent-600"></i>
                    </div>
                    <span>微信公众号：91爆料网</span>
                  </div>
                  <div className="flex items-center gap-3 text-sm text-foreground-700">
                    <div className="w-9 h-9 rounded-lg bg-secondary-100 flex items-center justify-center flex-shrink-0">
                      <i className="ri-phone-line text-secondary-600"></i>
                    </div>
                    <span>商务合作：010-8888-9999</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />

      {/* Schema.org structured data */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'AboutPage',
            name: '关于91爆料网',
            description: '全网独家吃瓜黑料第一站，你的吃瓜核心阵地。91爆料网是国内领先的娱乐资讯与网红爆料聚合平台。',
            url: 'http://cyhkjo.cn/about',
            publisher: {
              '@type': 'Organization',
              name: '91爆料网',
            },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: faqs.map((faq) => ({
              '@type': 'Question',
              name: faq.question,
              acceptedAnswer: {
                '@type': 'Answer',
                text: faq.answer,
              },
            })),
          }),
        }}
      />
    </>
  );
}